import CopyLink from "./Element/CopyLink";

// Instantiate ClipBoardJS
new CopyLink();